<template>
    <div class="main-list-wrap petition_details_wrap">
        <div>
            <div class="pad20">
                <div class="vx-row m-0 main-list-panel">
                    <div class="vx-col md:w-1/2 w-full p-0" v-if="checkProperty(petition,'beneficiaryInfo','houseHoldNumber')">
                        <div class="main-list">
                            <p>
                                Size of your household
                                <span>{{checkProperty(petition,'beneficiaryInfo','houseHoldNumber')}}</span>
                            </p>
                        </div>
                    </div>
                    <div class="vx-col md:w-1/2 w-full p-0" v-if="checkProperty(petition,'beneficiaryInfo','houseHoldAnnualIncome')">
                        <div class="main-list">
                            <p>
                                Indicate your annual household income
                                <span>{{radioValFormatter('houseHoldAnnualIncome', checkProperty(petition,'beneficiaryInfo','houseHoldAnnualIncome'))}}</span>
                            </p>
                        </div>
                    </div>
                    <div class="vx-col md:w-1/2 w-full p-0" v-if="checkProperty(petition,'beneficiaryInfo','houseHoldAnnualAssets')">
                        <div class="main-list">
                            <p>
                                Identify the total value of your household assets
                                <span>{{radioValFormatter('houseHoldAnnualAssets', petition['beneficiaryInfo']['houseHoldAnnualAssets'])}}</span>
                            </p>
                        </div>
                    </div>
                    <div class="vx-col md:w-1/2 w-full p-0" v-if="checkProperty(petition,'beneficiaryInfo','houseHoldAnnualliabilities')">
                        <div class="main-list">
                            <p>
                                Identify the total value of your household liabilities (including both secured and unsecured liabilities)
                                <span>{{radioValFormatter('houseHoldAnnualliabilities', checkProperty(petition,'beneficiaryInfo','houseHoldAnnualliabilities'))}}</span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import _ from "lodash";
export default {
    data: () => ({

    }),
    computed: {

    },
    components: {

    },
    props: {
        petition: {
            type: Object,
            default: null
        },
        tplsection:{
            type:String,
            default:'beneficiaryInfo'
        }
    },
    mounted() {
        
    },
    methods: {
        radioValFormatter(key='', val=null){
            let returnVal = '';
            let houseHoldAnnualIncomeList =[
                {id:'1',name:'$0-27,000'},
                {id:'2',name:'$27,001-52,000'},
                {id:'3',name:'$52,001-85,000'},
                {id:'4',name:'$85,001-141,000'},
                {id:'5',name:'Over $141,000'},
            ];
            let houseHoldAnnualAssetsList =[
                {id:'1',name:'$0-18,400'},
                {id:'2',name:'$18,401-136,000'},
                {id:'3',name:'$136,001-321,400'},
                {id:'4',name:'$321,401-707,100'},
                {id:'5',name:'Over $707,100'},
            ];
            let houseHoldAnnualliabilitiesList =[
                {id:'1',name:'$0'},
                {id:'2',name:'$1-10,100'},
                {id:'3',name:'$10,101-57,700'},
                {id:'4',name:'$57,701-186,800'},
                {id:'5',name:'Over $186,800'},
            ];
            if(key == 'houseHoldAnnualIncome' && val){
                let findObj = _.find(houseHoldAnnualIncomeList, {'id':val});
                if(findObj){
                    returnVal = findObj['name']
                }
            }
            if(key == 'houseHoldAnnualAssets' && val){
                let findObj = _.find(houseHoldAnnualAssetsList, {id:val});
                if(findObj){
                    returnVal = findObj['name']
                }
            }
            if(key == 'houseHoldAnnualliabilities' && val){
                let findObj = _.find(houseHoldAnnualliabilitiesList, {id:val});
                if(findObj){
                    returnVal = findObj['name']
                }
            }
            return returnVal;
        }
    }
}

</script>